import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProducts, productSelector } from "../../../api/productSlice";
import Loader from "../../../shared/loader";
import { Button, Divider } from "antd";
import Products from "./product";
import { Link, NavLink } from "react-router-dom";

export default function ProductIndex() {
  const { products, loading } = useSelector(productSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllProducts());
  }, [dispatch]);

  let Pproducts = products
    .filter((item) => item.hasPriority === true)
    .sort((a, b) => a.priority - b.priority);

  console.log(Pproducts);

  return (
    <div className="container md:px-5 px-2 md:py-12 py-4 mx-auto lg:w-4/5 block overflow-hidden ">
      <h2 className="text-[16px] ">Products</h2>
      <hr />
      <div className="flex flex-wrap w-full md:mt-5 mt-3 md:hidden ">
        <div className="md:p-2 p-1 w-1/2 overflow-hidden rounded-md  ">
        <NavLink to='/products-gifts'>
          <img
            alt="gallery"
            className="w-full object-cover cursor-pointer  transition duration-300 hover:scale-[1.1] rounded-md shadow-sm h-[16h] md:h-[26vh] lg:h-[36vh] object-center block"
            src={
              "https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fweb%20card-02%20(1).png?alt=media&token=cb7f3b07-efa0-48db-9df0-5f78a9235cdb"
            }
          />
          </NavLink>
        </div>
        <div className="md:p-2 p-1 w-1/2 overflow-hidden rounded-md  ">
        <NavLink to='/products-gifts'>
          <img
            alt="gallery"
            className="w-full object-cover cursor-pointer  transition duration-300 hover:scale-[1.1] rounded-md shadow-sm h-[16h] md:h-[26vh] lg:h-[36vh] object-center block"
            src={
              "https://firebasestorage.googleapis.com/v0/b/elegant-user.appspot.com/o/images%2Fweb%20card-01%20(1).png?alt=media&token=0bf6201c-1bf2-409a-a743-5d4f241da2d2"
            }
          />
          </NavLink>
        </div>
      </div>
      <div className="md:ml-12 ml-8 md:mt-10">
        {loading ? <Loader /> : <Products data={Pproducts} />}
      </div>

      <Button
        className=""
        style={{
          backgroundColor: "white",
          border: "1px solid #9a4c9d ",
          color: "#9a4c9d",
          fontSize: "1rem",
          float: "right",
          clear: "left",
        }}
        type="primary"
      >
        <Link to="/products-gifts">View More</Link>
      </Button>
      <br />
      <br></br>
    </div>
  );
}
